import { Component } from 'react';
import PropTypes from 'prop-types';
import { updateURLWithActiveVersion } from '%/utils/urlHandler';
import isMobile from '%/utils/isMobile';

export default class VehicleDetailsNewVehicles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startPosition: 0,
      mainCarousel: null,
      activeVersion: null,
    };

    this.initCarousels = this.initCarousels.bind(this);
    this.setStartPosition = this.setStartPosition.bind(this);
    this.setActiveVersion = this.setActiveVersion.bind(this);
    this.setActiveVersionInStore = this.setActiveVersionInStore.bind(this);
    this.handleCarouselChange = this.handleCarouselChange.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
  }

  componentDidMount() {
    const { defaultVersionSlug } = this.props;

    this.setStartPosition(defaultVersionSlug);
    this.initCarousels();
    this.handleVersionChange(defaultVersionSlug, false);
    this.watchStoredVersion();
  }

  handleCarouselChange(carousel, currentIndex) {
    const slides = carousel.Components.Elements.slides;
    const activeSlide = slides[currentIndex];
    const versionSlug = activeSlide.dataset.slug;

    this.handleVersionChange(versionSlug);
  }

  handleVersionChange(versionSlug, urlUpdate = true) {
    const activeVersion = this.findVersionBySlug(versionSlug);

    this.setActiveVersion(activeVersion);
    this.setActiveVersionInStore(activeVersion);

    if (urlUpdate) {
      updateURLWithActiveVersion(versionSlug);
    }
  }

  getVersionName(version) {
    return version.model || version.name;
  }

  setStartPosition(defaultVersionSlug) {
    const versionId = this.findVersionIdBySlug(defaultVersionSlug);
    const startPosition = versionId > 0 ? versionId : 0;

    this.setState({ startPosition });
  }

  setActiveVersion(activeVersion) {
    this.setState({ activeVersion });
  }

  setActiveVersionInStore(versionData) {
    window.store.vehicleVersionDetails.setState({
      activeVersion: versionData,
    });
  }

  watchStoredVersion() {
    window.store.vehicleVersionDetails.watch(state => {
      const { mainCarousel } = this.state;

      if (!mainCarousel) return;

      const indexCarousel = mainCarousel.index;
      const activeVersionId = this.findVersionIdBySlug(
        state.activeVersion.slug,
      );

      if (activeVersionId !== indexCarousel) {
        mainCarousel.go(activeVersionId);
      }
    });
  }

  findVersionBySlug(slug) {
    return this.props.versions.find(version => version.slug === slug);
  }

  findVersionIdBySlug(slug) {
    return this.props.versions.findIndex(version => version.slug === slug);
  }

  initCarousels() {
    const { startPosition } = this.state;
    const { versions } = this.props;

    const onlyTwoVersions = versions.length === 2;

    const mainCarousel = window.makeCarousel(this.carouselMainRef, {
      start: startPosition,
      type: 'fade',
      perPage: 1,
      focus: 'center',
      lazyLoad: 'nearby',
      preloadPages: 0,
      breakpoints: {
        576: {
          perPage: 1,
          padding: 0,
        },
      },
    });

    mainCarousel.on('move', newIndex => {
      this.handleCarouselChange(mainCarousel, newIndex);
    });

    if (isMobile()) return;

    const thumbnailCarousel = window.makeCarousel(this.thumbnailCarouselRef, {
      start: startPosition,
      fixedWidth: 150,
      fixedHeight: 80,
      isNavigation: true,
      gap: onlyTwoVersions ? 120 : 80,
      arrows: false,
      pagination: false,
      direction: 'ttb',
      height: onlyTwoVersions ? 490 : 580,
      padding: {
        bottom: onlyTwoVersions ? 0 : 90,
      },
    });

    thumbnailCarousel.on('move', newIndex => {
      this.handleCarouselChange(thumbnailCarousel, newIndex);
    });

    mainCarousel.sync(thumbnailCarousel);

    this.setState({ mainCarousel });
  }

  render() {
    const { activeVersion } = this.state;
    const { versions, arrowRightIcon, arrowLeftIcon } = this.props;

    return (
      <div
        className="vehicle-details__carousel-wrapper-content"
        data-single-version={versions.length === 1}
      >
        <div className="vehicle-details__info-box">
          <div className="vehicle-details__info-box-model">
            <h3 className="vehicle-details__info-box-title">
              {activeVersion && this.getVersionName(activeVersion)}
            </h3>
          </div>

          <div className="vehicle-details__info-box-price">
            <p className="vehicle-details__info-box-price-title">
              A partir de:
              <span className="vehicle-details__info-box-price-title--highlight">
                R$ {activeVersion && activeVersion.price}
              </span>
            </p>
          </div>

          <button type="button" className="btn button cta__datasheet">
            <i className="icon icon-circle-plus" />
            Ver Ficha técnica
          </button>
        </div>

        <div className="vehicle-details__carousel">
          <div
            className="vehicle-details__carousel-main splide"
            ref={node => {
              this.carouselMainRef = node;
            }}
          >
            <div className="splide__arrows">
              <button
                type="button"
                className="splide__arrow splide__arrow--prev"
              >
                <i className={`icon ${arrowLeftIcon}`} />
              </button>
              <button
                type="button"
                className="splide__arrow splide__arrow--next"
              >
                <i className={`icon ${arrowRightIcon}`} />
              </button>
            </div>

            <div className="splide__track">
              <div className="splide__list vehicle-details__carousel-main-items-wrapper">
                {versions.length > 0 &&
                  versions.map(version => (
                    <div
                      key={version.slug}
                      className="vehicle-details__carousel-main-item splide__slide"
                      data-slug={version.slug}
                    >
                      <picture>
                        <source
                          media="(max-width: 576px)"
                          srcSet={version.item_image.middle_image}
                        />
                        <img
                          className="vehicle-details__carousel-main-item-image"
                          src={version.item_image.main_image}
                          alt={`Imagem do ${this.getVersionName(version)}`}
                          width="533"
                          height="374"
                        />
                      </picture>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div
            className="vehicle-details__thumbnail-carousel splide"
            ref={node => {
              this.thumbnailCarouselRef = node;
            }}
          >
            <div className="splide__track">
              <div
                className="splide__list vehicle-details__thumbnail-carousel-items-wrapper"
                data-only-two-versions={versions.length === 2}
              >
                {versions.length > 0 &&
                  versions.map(version => (
                    <div
                      key={version.slug}
                      className="vehicle-details__thumbnail-carousel-item splide__slide"
                      data-slug={version.slug}
                    >
                      <img
                        className="vehicle-details__thumbnail-carousel-item-image"
                        src={version.item_image.thumb_image}
                        alt={`Imagem do ${this.getVersionName(version)}`}
                      />
                      <p className="vehicle-details__thumbnail-carousel-item-title">
                        {this.getVersionName(version)}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VehicleDetailsNewVehicles.defaultProps = {
  versions: [],
  defaultVersionSlug: '',
  arrowRightIcon: '',
  arrowLeftIcon: '',
};

VehicleDetailsNewVehicles.propTypes = {
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      model: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  defaultVersionSlug: PropTypes.string,
  arrowRightIcon: PropTypes.string,
  arrowLeftIcon: PropTypes.string,
};
